import BambooInput from './BambooInput.vue';

export default BambooInput;
